import { isGlobalFeatureEnabled } from "owa-feature-flags";
import type MeetingMessage from "owa-service/lib/contract/MeetingMessage";
import { isMeetingDelegated } from "./isMeetingDelegated";

function isEventPollItemClass(itemClass: string | undefined): boolean {
    return !!itemClass?.match(/^ipm\.(note\.)?schedule\.meeting\.eventpoll\.(request|canceled)/i);
}

export function isEventPollRequest(itemClass: string | undefined): boolean {
    return isGlobalFeatureEnabled("rp-event-poll-calendar-card") && isEventPollItemClass(itemClass);
}

export function isShareAvailabilityEmail(itemClass: string | undefined): boolean {
    return (isGlobalFeatureEnabled("cal-share-availability-email") && isEventPollItemClass(itemClass));
}

/**
 * Item-level share-availability eligibility: only received, non-delegated event polls in the
 * user's own mailbox use the availability presentation.
 */
export function isShareAvailabilityEmailMessage(message: MeetingMessage | undefined, mailboxInfo: {
    type: string;
} | undefined): boolean {
    return (!!message &&
        isShareAvailabilityEmail(message.ItemClass) &&
        !message.IsDraft &&
        mailboxInfo?.type === "UserMailbox" &&
        !isMeetingDelegated(message));
}

/**
 * True when the message should use the event-poll card path, either through the legacy event
 * poll flight or as an eligible share-availability email.
 */
export function isEventPollMessage(message: MeetingMessage | undefined, mailboxInfo: {
    type: string;
} | undefined): boolean {
    return (isEventPollRequest(message?.ItemClass) ||
        isShareAvailabilityEmailMessage(message, mailboxInfo));
}
